export interface Phase {
  value: string;
  label: string;
}

export const PHASES: Phase[] = [
  { value: 'REC',  label: 'Recon' },
  { value: 'CTX',  label: 'Context' },
  { value: 'CICD', label: 'CI/CD' },
  { value: 'CON',  label: 'Container' },
  { value: 'STR',  label: 'STRIDE' },
  { value: 'ASRG', label: 'ASRG' },
];

const KNOWN_PREFIXES = new Set(PHASES.map((p) => p.value));

/**
 * Derives the Phase from an External ID (e.g. "T-REC-001" → "REC").
 * Returns "NONE" for null/empty IDs, or "OTHER" for unrecognized prefixes.
 */
export function parsePhase(externalId: string | null | undefined): string {
  if (!externalId) return 'NONE';
  const parts = externalId.split('-');
  if (parts.length >= 3) {
    const middle = parts.slice(1, parts.length - 1).join('-').toUpperCase();
    if (KNOWN_PREFIXES.has(middle)) return middle;
    const first = parts[1].toUpperCase();
    if (KNOWN_PREFIXES.has(first)) return first;
  }
  return 'OTHER';
}

export function getPhasLabel(value: string): string {
  if (value === 'NONE') return 'Uncategorized';
  if (value === 'OTHER') return 'Other';
  return PHASES.find((p) => p.value === value)?.label ?? value;
}
